/** Payments API paths. The API URL interceptor supplies the environment-specific host. */
export const PAYMENTS_ENDPOINTS = {
  applicationConfigs: {
    get: '/api/ApplicationConfigs',
    current: '/api/ApplicationConfigs/current',
    byClientApp: (clientAppId: number) => `/api/ApplicationConfigs/client-app/${clientAppId}`,
    manageByClientApp: (clientAppId: number) => `/api/ApplicationConfigs/client-app/${clientAppId}/manage`,
    providers: '/api/ApplicationConfigs/providers',
    getById: (id: number) => `/api/ApplicationConfigs/${id}`,
    post: '/api/ApplicationConfigs',
    put: (id: number) => `/api/ApplicationConfigs/${id}`,
    delete: (id: number) => `/api/ApplicationConfigs/${id}`,
  },
  orders: {
    get: '/api/OrderRequests/MyOrderRequests',
    post: '/api/OrderRequests',
    getByOrderNumber: (orderNumber: string) => `/api/OrderRequests/orderNumber/${orderNumber}`,
    verify: (orderNumber: string) => `/api/OrderRequests/verify/${orderNumber}`,
    summary: '/api/OrderRequests/summary',
  },
  clientApps: {
    get: '/api/ClientApp',
    getById: (id: number) => `/api/ClientApp/${id}`,
    getPage: '/api/ClientApp/paged',
    post: '/api/ClientApp',
  },
  users: {
    get: '/api/Users',
    getPage: '/api/Users/paged',
    post: '/api/Users/register',
    put: (username: string) => `/api/Users/${username}`,
    delete: (username: string) => `/api/Users/${username}`,
    putPassword: (username: string) => `/api/Users/${username}/password`,
    login: '/api/Users/login',
    current: '/api/Users/CurrentUser',
  },
  payments: {
    post: '/api/PaymentRequests',
    closeBatch: '/api/PaymentRequests/batch/close',
    openBatchTransactions: '/api/PaymentRequests/open-batch/transactions',
  },
  payroc: {
    hostedFieldsSession: '/api/Payroc/hosted-fields-session',
    pay: '/api/Payroc/pay-hosted-fields',
    payCardPresent: '/api/Payroc/pay-card-present',
    refund: '/api/Payroc/refund',
    void: '/api/Payroc/void',
  },
  paywire: {
    authenticate: '/api/AuthToken/authenticate',
    response: '/api/PaywireResponses',
  },
} as const;
